import DigitalAssetPagingResultModelBase from '../_generated/modelBases/digital-asset-paging-result-model-base';

export default class DigitalAssetPagingResultModel extends DigitalAssetPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
